export default __webpack_public_path__ + "static/media/text.b9ba48c7.svg";